import React from "react";
import { Redirect } from "react-router-dom";
import Genres from "../User/genres";
import ShopReserved from "../Shop/ShopReserved";
import ErrorComponent from "../Static/Error";
import {
  getPublicPageBySlug,
  isKidsSectionEnabled,
  isShopSectionEnabled,
} from "./siteContent";

/**
 * Gate for configurable public browse slugs (white-label).
 * Unknown slugs show a branded not-found experience (UI-020 / PR-009) —
 * they must not silently redirect to /home or fall into Genres as movies.
 * Kids / Shop are omitted when their sections are disabled.
 * /shop is reserved for commerce and shows the Coming Soon placeholder.
 */
const PublicBrowseGate = (props) => {
  const slug =
    (props.match && props.match.params && props.match.params.publicSlug) || "";
  const normalized = String(slug).toLowerCase();

  // /shop is reserved for commerce — never treat as Kids browse or unknown.
  if (normalized === "shop") {
    if (!isShopSectionEnabled()) {
      return <Redirect to="/home" />;
    }
    return <ShopReserved {...props} />;
  }

  const page = getPublicPageBySlug(slug);

  if (!page) {
    return <ErrorComponent variant="notFound" />;
  }

  if (
    (page.key === "kids" || page.page_type === "KIDS") &&
    !isKidsSectionEnabled()
  ) {
    return <Redirect to="/home" />;
  }

  if (
    (page.key === "shop" || page.page_type === "SHOP") &&
    !isShopSectionEnabled()
  ) {
    return <Redirect to="/home" />;
  }

  return <Genres {...props} />;
};

export default PublicBrowseGate;
